module.exports = __webpack_public_path__ + "static/media/wordmark.c3a93575.svg";